import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  FiBriefcase,
  FiCheckCircle,
  FiPlusCircle,
  FiTrendingUp,
} from "react-icons/fi";

import {
  Calendar,
  ChevronDown,
  IndianRupee,
  MapPin,
  Maximize2,
} from "lucide-react";

import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";

import { useNavigate } from "react-router-dom";
import api from "../../configs/api";

import MarketInsightCard from "../../components/admin/my-properties/MarketInsightCard";
import MarketInsightGraph from "../../components/admin/my-properties/MarketInsightGraph";
import PropertyCard from "../../components/admin/my-properties/PropertyCard";
import NoPropertiesFound from "../../components/admin/skeleton-loaders/properties/NoPropertiesFound";
import PropertyGridSkeleton from "../../components/admin/skeleton-loaders/properties/PropertyGridSkeleton";
import { formatPrice, timeAgo } from "../../utils/helpers";
import { showError, showSuccess } from "../../utils/toastUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const statsData = [
  {
    id: 1,
    title: "No of Commercial Property",
    value: "12",
    link: "View all Leads",
    percentage: "0.29%",
    isPositive: true,
    icon: FiBriefcase,
    iconBg: "#735DFF",
  },
  {
    id: 2,
    title: "Property Listed Today",
    value: "200",
    link: "complete revenue",
    percentage: "3.45%",
    isPositive: false,
    icon: FiPlusCircle,
    iconBg: "#FF5A29",
  },
  {
    id: 3,
    title: "Active Deals",
    value: "20",
    link: "Total page views",
    percentage: "11.54%",
    isPositive: true,
    icon: FiTrendingUp,
    iconBg: "#0CC763",
  },
  {
    id: 4,
    title: "Deal Closed",
    value: "40",
    link: "Total profit earned",
    percentage: "0.18%",
    isPositive: true,
    icon: FiCheckCircle,
    iconBg: "#0C9CFC",
  },
];

const StatCard = ({
  title,
  value,
  link,
  percentage,
  isPositive,
  icon: Icon,
  iconBg,
}) => (
  <div className="bg-background-card rounded-lg p-4 sm:p-5 shadow-sm">
    <div className="flex justify-between items-start mb-4">
      <div>
        <p className="text-text-primary font-medium text-sm mb-2">{title}</p>
        <h3 className="text-2xl font-semibold text-text-primary">{value}</h3>
      </div>
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center"
        style={{ backgroundColor: iconBg }}
      >
        <Icon className="text-white text-xl size-7" />
      </div>
    </div>
    <div className="flex justify-between items-center">
      <button className="text-text-muted capitalize underline underline-offset-2 text-sm hover:text-primary">
        {link}
      </button>
      <span
        className={`text-sm font-semibold ${
          isPositive ? "text-status-success" : "text-status-danger"
        }`}
      >
        {percentage}
      </span>
    </div>
  </div>
);

// const FilterBar = ({ filters, setFilters, locations, sticky = true }) => {
//   const [isSticky, setIsSticky] = useState(false);

//   useEffect(() => {
//     if (!sticky) return;

//     let rafId = null;
//     let ticking = false;
//     let lastY = 0;

//     const onScroll = () => {
//       lastY = window.scrollY;
//       if (!ticking) {
//         rafId = requestAnimationFrame(() => {
//           setIsSticky(lastY > 100);
//           ticking = false;
//         });
//         ticking = true;
//       }
//     };

//     window.addEventListener("scroll", onScroll, { passive: true });
//     return () => {
//       window.removeEventListener("scroll", onScroll);
//       rafId && cancelAnimationFrame(rafId);
//     };
//   }, [sticky]);

//   const selectClasses = `
//     relative w-full appearance-none cursor-pointer
//     bg-gradient-to-br from-white to-gray-50/50
//     border border-border hover:border-primary/30
//     focus:border-primary focus:ring-1 focus:ring-primary/20
//     rounded-md sm:rounded-lg 
//     px-2 xs:px-3 sm:px-4 md:px-5
//     py-1.5 xs:py-2 sm:py-2.5
//     pr-7 xs:pr-8 sm:pr-9
//     text-[10px] xs:text-xs sm:text-sm 
//     text-text-primary font-medium
//     transition-all duration-200
//     shadow-sm hover:shadow-md
//     focus:outline-none
//     truncate
//   `;

//   return (
//     <div
//       className={`
//         bg-white/95 backdrop-blur-sm
//         transition-all duration-300
//         ${sticky ? "sticky top-0 z-40" : ""}
//         ${
//           isSticky
//             ? "rounded-b-lg shadow-lg shadow-primary/5"
//             : "rounded-lg shadow-sm"
//         }
//       `}
//     >
//       <div
//         className="
//           grid grid-cols-4 gap-1.5 xs:gap-2 sm:gap-3 md:gap-4
//           p-2 xs:p-3 sm:p-4
//           transition-all duration-300
//         "
//       >
//         {/* Location */}
//         <div className="flex flex-col group">
//           <label
//             className={`text-xs sm:text-sm font-semibold text-text-primary flex items-center gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }`}
//           >
//             <MapPin className="w-3.5 h-3.5 text-primary" />
//             Location
//           </label>

//           <div className="relative">
//             <select
//               className={selectClasses}
//               value={filters.city}
//               onChange={(e) =>
//                 setFilters((prev) => ({ ...prev, city: e.target.value }))
//               }
//             >
//               <option value="">Select Location</option>
//               {locations.map((city) => (
//                 <option key={city}>{city}</option>
//               ))}
//             </select>
//             <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-primary/60 w-4 h-4" />
//           </div>
//         </div>

//         {/* Budget */}
//         <div className="flex flex-col group">
//           <label
//             className={`text-xs sm:text-sm font-semibold text-text-primary flex gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }`}
//           >
//             <IndianRupee className="w-3.5 h-3.5 text-status-success" />
//             Budget
//           </label>

//           <div className="relative">
//             <select
//               className={selectClasses}
//               onChange={(e) =>
//                 setFilters((prev) => ({ ...prev, budget: e.target.value }))
//               }
//             >
//               <option value="30-50">₹30L-50L</option>
//               <option value="50-100">₹50L-1Cr</option>
//               <option value="100-500">₹1Cr-5Cr</option>
//             </select>
//             <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-primary/60 w-4 h-4" />
//           </div>
//         </div>

//         {/* Size */}
//         <div className="flex flex-col group">
//           <label
//             className={`text-xs sm:text-sm font-semibold text-text-primary flex gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }`}
//           >
//             <Maximize2 className="w-3.5 h-3.5 text-status-info" />
//             Size
//           </label>

//           <div className="relative">
//             <select
//               className={selectClasses}
//               value={filters.size}
//               onChange={(e) =>
//                 setFilters((prev) => ({ ...prev, size: e.target.value }))
//               }
//             >
//               <option value="">Size</option>
//               <option value="0-500">Below 500 sqft</option>
//               <option value="500-1000">500-1000 sqft</option>
//               <option value="1000+">Above 1000 sqft</option>
//             </select>
//             <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-primary/60 w-4 h-4" />
//           </div>
//         </div>

//         {/* Date */}
//         <div className="flex flex-col group">
//           <label
//             className={`text-xs sm:text-sm font-semibold text-text-primary flex gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }`}
//           >
//             <Calendar className="w-3.5 h-3.5 text-btn-brandYellow" />
//             Date
//           </label>

//           <div className="relative">
//             <input
//               type="date"
//               className={`
//                 ${selectClasses}
//                 [&::-webkit-calendar-picker-indicator]:opacity-0
//               `}
//               value={filters.date}
//               onChange={(e) =>
//                 setFilters((prev) => ({ ...prev, date: e.target.value }))
//               }
//             />
//             <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 text-primary/60 w-4 h-4" />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

const AddListingDropdown = React.memo(() => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const addOptions = [
    { label: "Add Property", path: "add/residential" },
    { label: "Add Project", path: "add/project" },
    { label: "Add Plot/Land", path: "add/land" },
    { label: "Add Commercial Property", path: "add/commercial" },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside, true);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside, true);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setOpen((p) => !p)}
        className="bg-primary-navy text-white border-2 border-white px-4 py-3 rounded-xl hover:scale-[1.01] active:scale-[0.98] transition-transform text-sm font-medium flex items-center gap-2"
      >
        Add Listing
        <ChevronDown
          className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white shadow-lg rounded-xl ring-1 ring-gray-200 overflow-hidden animate-fade-in z-20">
          {addOptions.map((item, i) => (
            <button
              key={i}
              onClick={() => {
                navigate(item.path);
                setOpen(false);
              }}
              className="w-full text-left px-4 py-2.5 text-sm text-text-primary hover:bg-primary/5 hover:text-primary"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
});

const PropertyList = ({ isLoading, properties, fetchProperties }) => {
  const navigate = useNavigate();

  if (isLoading) return <PropertyGridSkeleton />;
  if (!properties || properties.length === 0) return <NoPropertiesFound />;

  const handleEdit = (id, type) => {
    navigate(`/admin/properties/edit/${type}/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete this property?"))
        return;

      await api.delete(`/properties/${id}`);
      fetchProperties();
      showSuccess("Property deleted successfully.");
    } catch (err) {
      console.error("Delete failed:", err);
      showError("Failed to delete property. Please try again.");
    }
  };

  return (
    <div className="lg:col-span-2 space-y-4 scroll-overlay">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {properties.map((prop) => (
          <MemoPropertyCard
            key={prop.id}
            {...prop}
            onEdit={(id) => handleEdit(id, prop.type)}
            onDelete={(id) => handleDelete(id)}
          />
        ))}
      </div>
    </div>
  );
};


const MyProperties = () => {
  const [properties, setProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);

  const [filters, setFilters] = useState({
    city: "",
    budget: "",
    size: "",
    date: "",
  });

  const rawPropertiesRef = useRef([]);

  const fetchProperties = useCallback(async () => {
    try {
      setLoading(true);

      const res = await api.get("/properties/listed-by");
      rawPropertiesRef.current = res.data?.data || [];

      const formatted = rawPropertiesRef.current.map((item) => {
        const thumbnail =
          item.images?.find((img) => img.isThumbnail)?.url ||
          item.images?.[0]?.url;

        const getPriceValue = (property) => {
          switch (item.type) {
            case "land":
              return (
                property?.expectedPrice ||
                property?.pricePerSqft * property?.carpetArea?.value
              );

            case "commercial":
              return (
                property?.allowedForConstructionDetails?.expectedPrice ||
                property?.price
              );

            case "project":
              return property?.price || property?.floorPlan?.[0]?.expectedPrice;

            case "residential":
              return property?.floorPlan?.expectedPrice || property?.price;

            default:
              return (
                property?.expectedPrice ||
                property?.price ||
                property?.floorPlan?.expectedPrice
              );
          }
        };

        const numericPrice = getPriceValue(item.property) || 0;

        return {
          id: item._id,
          image: thumbnail,
          title: item?.title || item.property?.projectName || "Unnamed Project",
          location: item.location || "",
          numericPrice,
          price: formatPrice(numericPrice),
          timeAgo: timeAgo(item.createdAt),
          type: item.type,
          createdAt: item.createdAt,
          _raw: item,
        };
      });

      setProperties(formatted);
      setFilteredProperties(formatted);
    } catch (err) {
      console.error("Error fetching properties:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProperties();
  }, [fetchProperties]);

  useEffect(() => {
    if (properties.length > 0) {
      const uniqueCities = [
        ...new Set(
          properties
            .map((p) => p.location?.address?.city)
            .filter((city) => city && city.trim() !== "")
        ),
      ];
      setLocations(uniqueCities);
    }
  }, [properties]);

  // const filteredMemo = useMemo(() => {
  //   let updated = [...properties];

  //   if (filters.city) {
  //     updated = updated.filter(
  //       (p) =>
  //         p.location?.address?.city?.toLowerCase() ===
  //         filters.city.toLowerCase()
  //     );
  //   }

  //   if (filters.budget) {
  //     const [minL, maxL] = filters.budget.split("-").map(Number);
  //     const min = minL * 100000;
  //     const max = maxL * 100000;

  //     updated = updated.filter(
  //       (p) => p.numericPrice >= min && p.numericPrice <= max
  //     );
  //   }

  //   if (filters.size) {
  //     updated = updated.filter((p) => {
  //       const sqft =
  //         p._raw?.property?.carpetArea?.value ||
  //         p._raw?.property?.floorPlan?.carpetArea?.value ||
  //         p._raw?.property?.allowedForConstructionDetails?.carpetArea?.value ||
  //         p._raw?.property?.floors?.totalArea?.value ||
  //         0;

  //       if (filters.size.includes("+")) {
  //         const min = Number(filters.size.replace("+", ""));
  //         return sqft >= min;
  //       }

  //       const [min, max] = filters.size.split("-").map(Number);
  //       return sqft >= min && sqft <= max;
  //     });
  //   }

  //   if (filters.date) {
  //     updated = updated.filter((p) => {
  //       const created = new Date(p.createdAt).toISOString().slice(0, 10);
  //       return created === filters.date;
  //     });
  //   }

  //   return updated;
  // }, [filters, properties]);

  // useEffect(() => {
  //   setFilteredProperties(filteredMemo);
  // }, [filteredMemo]);

  return (
    <div className="font-quicksand bg-background py-3 sm:py-4 md:py-6 pl-3 sm:pl-4 md:pl-6 pr-2 sm:pr-3 md:pr-4">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="mb-4 cursor-default font-poppins">
          <h1 className="text-2xl font-semibold text-text-primary mb-1">
            My Properties
          </h1>
          <p className="text-text-muted text-sm">My Plots</p>
        </div>

        <AddListingDropdown />
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        {statsData.map((stat) => (
          <MemoStatCard key={stat.id} {...stat} />
        ))}
      </div>

      {/* Main Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        {/* Left */}
        <div className="lg:col-span-9 space-y-4">
          {/* <MemoFilterBar
            filters={filters}
            setFilters={setFilters}
            locations={locations}
          /> */}

          <MemoPropertyList
            isLoading={loading}
            properties={filteredProperties}
            fetchProperties={fetchProperties}
          />
        </div>

        {/* Right Sidebar */}
        <div className="lg:col-span-3">
          <div className="lg:sticky lg:top-4 space-y-4">
            <MemoMarketInsightCard />
            <MemoMarketInsightGraph />
          </div>
        </div>
      </div>
    </div>
  );
};
const MemoStatCard = React.memo(StatCard);
// const MemoFilterBar = React.memo(FilterBar);
const MemoMarketInsightGraph = React.memo(MarketInsightGraph);
const MemoMarketInsightCard = React.memo(MarketInsightCard);
const MemoPropertyCard = React.memo(PropertyCard);
const MemoPropertyList = React.memo(PropertyList);

export default MyProperties;

// import {
//   FiBriefcase,
//   FiPlusCircle,
//   FiTrendingUp,
//   FiCheckCircle,
// } from "react-icons/fi";
// import React, { useState, useEffect, useRef } from "react";
// import {
//   ChevronDown,
//   MapPin,
//   IndianRupee,
//   Maximize2,
//   Calendar,
//   TrendingUp,
//   TrendingDown,
// } from "lucide-react";

// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Bar, Line } from "react-chartjs-2";
// import { useNavigate } from "react-router-dom";
// import api from "../../configs/api";
// import {
//   formatPrettyAddress,
//   formatPrice,
//   getPrice,
//   timeAgo,
// } from "../../utils/helpers";
// import NoPropertiesFound from "../../components/admin/skeleton-loaders/properties/NoPropertiesFound";
// import PropertyGridSkeleton from "../../components/admin/skeleton-loaders/properties/PropertyGridSkeleton";
// import { MdDelete, MdEdit } from "react-icons/md";
// import { showError, showSuccess } from "../../utils/toastUtils";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const statsData = [
//   {
//     id: 1,
//     title: "No of Commercial Property",
//     value: "12",
//     link: "View all Leads",
//     percentage: "0.29%",
//     isPositive: true,
//     icon: FiBriefcase, // Represents business/commercial properties
//     iconBg: "#735DFF",
//   },
//   {
//     id: 2,
//     title: "Property Listed Today",
//     value: "200",
//     link: "complete revenue",
//     percentage: "3.45%",
//     isPositive: false,
//     icon: FiPlusCircle, // Perfect for "new listings" or "added items"
//     iconBg: "#FF5A29",
//   },
//   {
//     id: 3,
//     title: "Active Deals",
//     value: "20",
//     link: "Total page views",
//     percentage: "11.54%",
//     isPositive: true,
//     icon: FiTrendingUp, // Symbolizes ongoing/performing deals
//     iconBg: "#0CC763",
//   },
//   {
//     id: 4,
//     title: "Deal Closed",
//     value: "40",
//     link: "Total profit earned",
//     percentage: "0.18%",
//     isPositive: true,
//     icon: FiCheckCircle, // Signifies completion/success
//     iconBg: "#0C9CFC",
//   },
// ];

// // Stat Card Component
// const StatCard = ({
//   title,
//   value,
//   link,
//   percentage,
//   isPositive,
//   icon: Icon,
//   iconBg,
// }) => (
//   <div className="bg-background-card rounded-lg p-4 sm:p-5 shadow-sm">
//     <div className="flex justify-between items-start mb-4">
//       <div>
//         <p className="text-text-primary font-medium text-sm mb-2">{title}</p>
//         <h3 className="text-2xl font-semibold text-text-primary">{value}</h3>
//       </div>
//       <div
//         className="w-12 h-12 rounded-full flex items-center justify-center"
//         style={{ backgroundColor: iconBg }}
//       >
//         <Icon className="text-white text-xl size-7" />
//       </div>
//     </div>
//     <div className="flex justify-between items-center">
//       <button className="text-text-muted capitalize leading-relaxed underline underline-offset-2 cursor-pointer text-sm hover:text-primary">
//         {link}
//       </button>
//       <span
//         className={`text-sm font-semibold ${
//           isPositive ? "text-status-success" : "text-status-danger"
//         }`}
//       >
//         {percentage}
//       </span>
//     </div>
//   </div>
// );

// const FilterBar = ({ filters, setFilters, locations, sticky = true }) => {
//   const [isSticky, setIsSticky] = useState(false);

//   useEffect(() => {
//     if (!sticky) return;

//     const handleScroll = () => {
//       setIsSticky(window.scrollY > 100);
//       console.log("sticky:", window.scrollY > 100);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [sticky]);

//   const selectClasses = `
//     relative w-full appearance-none cursor-pointer
//     bg-gradient-to-br from-white to-gray-50/50
//     border border-border hover:border-primary/30
//     focus:border-primary focus:ring-1 focus:ring-primary/20
//     rounded-md sm:rounded-lg
//     px-2 xs:px-3 sm:px-4 md:px-5
//     py-1.5 xs:py-2 sm:py-2.5
//     pr-7 xs:pr-8 sm:pr-9
//     text-[10px] xs:text-xs sm:text-sm
//     text-text-primary font-medium
//     transition-all duration-200
//     shadow-sm hover:shadow-md
//     focus:outline-none
//     truncate
//   `;

//   const wrapperClasses = `
//     relative
//     before:absolute before:inset-0
//     before:rounded-md sm:before:rounded-lg
//     before:bg-gradient-to-br before:from-primary/5 before:to-transparent
//     before:opacity-0 hover:before:opacity-100
//     before:transition-opacity before:duration-300
//     before:pointer-events-none
//   `;

//   const iconClasses = `
//     absolute right-2 xs:right-2.5 sm:right-3
//     top-1/2 -translate-y-1/2
//     pointer-events-none
//     text-primary/60
//     transition-transform duration-200
//   `;

//   return (
//     <div
//       className={`
//         bg-white/95 backdrop-blur-sm
//         transition-all  duration-300
//         ${sticky ? "sticky top-0 z-40" : ""}
//         ${isSticky ? "rounded-b-lg" : "rounded-lg"}
//         ${isSticky ? "shadow-lg shadow-primary/5" : "shadow-sm"}
//       `}
//     >
//       <div
//         className={`
//           grid grid-cols-4
//           gap-1.5 xs:gap-2 sm:gap-3 md:gap-4
//           p-2 xs:p-3 sm:p-4
//           transition-all duration-300
//         `}
//       >
//         {/* Location */}
//         <div className="flex flex-col group">
//           <label
//             className={`
//               text-xs sm:text-sm font-semibold text-text-primary
//               transition-all duration-300
//               flex items-center gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }
//             `}
//           >
//             <MapPin className="w-3.5 h-3.5 text-primary" />
//             Location
//           </label>
//           <div className={wrapperClasses}>
//             <select
//               className={selectClasses}
//               value={filters.city}
//               onChange={(e) =>
//                 setFilters((prev) => ({ ...prev, city: e.target.value }))
//               }
//             >
//               <option value="">Select Location</option>

//               {locations.map((city) => (
//                 <option key={city} value={city}>
//                   {city}
//                 </option>
//               ))}
//             </select>

//             <ChevronDown
//               className={`${iconClasses} w-3.5 xs:w-4 sm:w-4 h-3.5 xs:h-4 sm:h-4 group-hover:translate-y-0.5`}
//             />
//           </div>
//         </div>

//         {/* Budget */}
//         <div className="flex flex-col group">
//           <label
//             className={`
//               text-xs sm:text-sm font-semibold text-text-primary
//               transition-all duration-300
//               flex items-center gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }
//             `}
//           >
//             <IndianRupee className="w-3.5 h-3.5 text-status-success" />
//             Budget
//           </label>
//           <div className={wrapperClasses}>
//             <select className={selectClasses}>
//               <option value="30-50">₹30L-50L</option>
//               <option value="50-100">₹50L-1Cr</option>
//               <option value="100-500">₹1Cr-5Cr</option>
//             </select>
//             <ChevronDown
//               className={`${iconClasses} w-3.5 xs:w-4 sm:w-4 h-3.5 xs:h-4 sm:h-4 group-hover:translate-y-0.5`}
//             />
//           </div>
//         </div>

//         {/* Size */}
//         <div className="flex flex-col group">
//           <label
//             className={`
//               text-xs sm:text-sm font-semibold text-text-primary
//               transition-all duration-300
//               flex items-center gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }
//             `}
//           >
//             <Maximize2 className="w-3.5 h-3.5 text-status-info" />
//             Size
//           </label>
//           <div className={wrapperClasses}>
//             <select
//               className={selectClasses}
//               value={filters.size}
//               onChange={(e) =>
//                 setFilters((prev) => ({ ...prev, size: e.target.value }))
//               }
//             >
//               <option value="">Size</option>
//               <option value="0-500">Below 500 sqft</option>
//               <option value="500-1000">500-1000 sqft</option>
//               <option value="1000+">Above 1000 sqft</option>
//             </select>

//             <ChevronDown
//               className={`${iconClasses} w-3.5 xs:w-4 sm:w-4 h-3.5 xs:h-4 sm:h-4 group-hover:translate-y-0.5`}
//             />
//           </div>
//         </div>

//         {/* Date */}
//         <div className="flex flex-col group">
//           <label
//             className={`
//               text-xs sm:text-sm font-semibold text-text-primary
//               transition-all duration-300
//               flex items-center gap-1.5
//               ${
//                 isSticky
//                   ? "h-0 opacity-0 mb-0"
//                   : "h-auto opacity-100 mb-1.5 sm:mb-2 hidden sm:flex"
//               }
//             `}
//           >
//             <Calendar className="w-3.5 h-3.5 text-btn-brandYellow" />
//             Date
//           </label>
//           <div className={`${wrapperClasses} relative`}>
//             <input
//               type="date"
//               className={`
//                 ${selectClasses}
//                 [&::-webkit-calendar-picker-indicator]:opacity-0
//                 [&::-webkit-calendar-picker-indicator]:absolute
//                 [&::-webkit-calendar-picker-indicator]:inset-0
//                 [&::-webkit-calendar-picker-indicator]:w-full
//                 [&::-webkit-calendar-picker-indicator]:h-full
//                 [&::-webkit-calendar-picker-indicator]:cursor-pointer
//               `}
//               value={filters.date}
//               onChange={(e) =>
//                 setFilters((prev) => ({ ...prev, date: e.target.value }))
//               }
//             />

//             <Calendar
//               className={`${iconClasses} w-3.5 xs:w-4 sm:w-4 h-3.5 xs:h-4 sm:h-4`}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const MarketInsightGraph = () => {
//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         backgroundColor: "#000750",
//         padding: 12,
//         borderRadius: 8,
//       },
//     },
//     scales: {
//       x: {
//         grid: { display: false },
//         ticks: { font: { size: 10 } },
//       },
//       y: {
//         grid: { color: "#f3f4f6" },
//         ticks: { font: { size: 10 } },
//       },
//     },
//   };
//   const barData = {
//     labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
//     datasets: [
//       {
//         label: "This Week",
//         data: [12, 15, 13, 18, 16, 19, 14],
//         backgroundColor: "#735DFF",
//         borderRadius: 8,
//       },
//       {
//         label: "Last Week",
//         data: [10, 12, 14, 11, 13, 15, 12],
//         backgroundColor: "#FF5A29",
//         borderRadius: 8,
//       },
//     ],
//   };
//   return (
//     <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
//       <div className="flex items-center justify-between mb-3">
//         <h4 className="font-semibold text-text-primary">
//           Market Insight Graph
//         </h4>
//         <button className="text-xs text-text-muted flex items-center gap-1">
//           Sort By <ChevronDown className="w-3 h-3" />
//         </button>
//       </div>
//       <div className="flex items-center gap-4 mb-3 text-xs">
//         <div>
//           <span className="font-bold text-lg">14,642</span>
//           <span className="text-status-success ml-1 inline-flex items-center">
//             <TrendingUp className="w-3 h-3" /> 6.44k
//           </span>
//           <p className="text-text-muted">This Week</p>
//         </div>
//         <div>
//           <span className="font-bold text-lg">12,326</span>
//           <span className="text-status-danger ml-1 inline-flex items-center">
//             <TrendingDown className="w-3 h-3" /> 2.13k
//           </span>
//           <p className="text-text-muted">Last Week</p>
//         </div>
//       </div>
//       <div className="h-48">
//         <Bar
//           data={barData}
//           options={{
//             ...chartOptions,
//             plugins: {
//               ...chartOptions.plugins,
//               legend: {
//                 display: true,
//                 position: "bottom",
//                 labels: { boxWidth: 12, font: { size: 10 } },
//               },
//             },
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// const MarketInsightCard = () => {
//   const priceData = {
//     labels: ["Jun", "Feb", "Mar", "Apr", "May", "Jun"],
//     datasets: [
//       {
//         data: [30, 38, 35, 40, 45, 48],
//         borderColor: "#735DFF",
//         backgroundColor: "rgba(115, 93, 255, 0.1)",
//         tension: 0.4,
//         fill: true,
//         pointRadius: 0,
//         borderWidth: 2,
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         backgroundColor: "#000750",
//         padding: 12,
//         borderRadius: 8,
//       },
//     },
//     scales: {
//       x: {
//         grid: { display: false },
//         ticks: { font: { size: 10 } },
//       },
//       y: {
//         grid: { color: "#f3f4f6" },
//         ticks: { font: { size: 10 } },
//       },
//     },
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-sm p-4">
//       <h3 className="font-bold text-text-primary mb-4 text-lg">
//         Market Insights
//       </h3>

//       <div className="mb-6">
//         <p className="text-sm text-text-secondary mb-2">Avg price trends</p>
//         <p className="text-xs text-text-muted mb-3">₹36.00 (₹ +8 L)</p>
//         <div className="h-32">
//           <Line data={priceData} options={chartOptions} />
//         </div>
//       </div>

//       <div className="">
//         <h4 className="font-semibold text-text-primary mb-2">
//           Market Consumption
//         </h4>
//         <div className=" flex items-start justify-between bg-blue-50 rounded-lg p-3 mb-2">
//           <div>
//             <p className="font-semibold text-text-primary text-sm">
//               Basic Agent
//             </p>
//             <p className="text-xs text-text-secondary">
//               Plan expires on <br /> Oct 12, 2024
//             </p>
//           </div>
//           <button className="mt-2 bg-primary text-white px-4 py-2 rounded-lg text-xs font-medium hover:bg-opacity-90 whitespace-nowrap">
//             Upgrade Plan
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const AddListingDropdown = () => {
//   const [open, setOpen] = useState(false);
//   const dropdownRef = useRef(null);
//   const navigate = useNavigate();
//   // let hoverTimeout = useRef(null);

//   const addOptions = [
//     { label: "Add Property", path: "add/residential" },
//     { label: "Add Project", path: "add/project" },
//     { label: "Add Plot/Land", path: "add/land" },
//     { label: "Add Commercial Property", path: "add/commercial" },
//   ];

//   // Close dropdown on outside click
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside, true);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside, true);
//     };
//   }, []);

//   return (
//     <div
//       className="relative"
//       ref={dropdownRef}
//       // onMouseEnter={() => {
//       //   clearTimeout(hoverTimeout.current);
//       //   setOpen(true);
//       // }}
//       // onMouseLeave={() => {
//       //   hoverTimeout.current = setTimeout(() => setOpen(false), 200);
//       // }}
//     >
//       <button
//         onClick={() => setOpen((prev) => !prev)}
//         className="bg-primary-navy text-white border-2 border-white px-4 py-3 rounded-xl hover:scale-[1.01] active:scale-[0.98] transition-transform transform-gpu duration-100 text-sm font-medium hover:bg-opacity-90 flex items-center gap-2"
//       >
//         Add Listing
//         <ChevronDown
//           className={`w-4 h-4 transition-transform duration-200 ${
//             open ? "rotate-180" : "rotate-0"
//           }`}
//         />
//       </button>

//       {open && (
//         <div className="absolute right-0 mt-2 w-56 bg-white shadow-lg rounded-xl ring-1 ring-gray-200 overflow-hidden animate-fade-in z-20">
//           {addOptions.map((item, index) => (
//             <button
//               key={index}
//               onClick={() => {
//                 navigate(item.path);
//                 setOpen(false);
//               }}
//               className="w-full text-left px-4 py-2.5 text-sm text-text-primary hover:bg-primary/5 hover:text-primary transition-colors duration-150"
//             >
//               {item.label}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const PropertyCard = ({
//   id,
//   image,
//   title,
//   location,
//   price,
//   timeAgo,
//   onEdit,
//   onDelete,
// }) => {
//   const navigate = useNavigate();

//   const handleEdit = (e) => {
//     e.stopPropagation();
//     onEdit?.(id);
//   };

//   const handleDelete = (e) => {
//     e.stopPropagation();
//     onDelete?.(id);
//   };

//   return (
//     <div
//       onClick={() => {
//         navigate(`/admin/properties/details/${id}`);
//       }}
//       className="bg-white cursor-pointer font-poppins rounded-lg shadow-sm hover:shadow-lg transition-all overflow-hidden group"
//     >
//       <div className="relative overflow-hidden aspect-[5/4]">
//         <img
//           src={image}
//           alt={title}
//           className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
//         />

//         {/* Action buttons - appear on hover */}
//         <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
//           <button
//             onClick={handleEdit}
//             className="bg-white/70 backdrop-blur-sm p-2 rounded-lg shadow-md hover:bg-blue-50 hover:scale-110 transition-all"
//             aria-label="Edit property"
//           >
//             <MdEdit className="w-4 h-4 text-blue-600" />
//           </button>

//           <button
//             onClick={handleDelete}
//             className="bg-white/70 backdrop-blur-sm p-2 rounded-lg shadow-md hover:bg-red-50 hover:scale-110 transition-all"
//             aria-label="Delete property"
//           >
//             <MdDelete className="w-4 h-4 text-red-600" />
//           </button>
//         </div>
//       </div>
//       <div className="p-3 flex flex-col gap-y-2">
//         <h3 className="font-medium text-[#031722]  text-xs line-clamp-1">
//           {title}
//         </h3>
//         <p className="text-[10px] text-text-secondary  line-clamp-1 leading-tight">
//           {formatPrettyAddress(location)}
//         </p>
//         <div className="flex items-center justify-between">
//           <span className="text-[#031722] font-medium text-xs">{price}</span>
//           <span className="text-[10px] text-text-muted">{timeAgo}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// const PropertyList = ({ isLoading, properties, fetchProperties }) => {
//   const navigate = useNavigate();
//   if (isLoading) return <PropertyGridSkeleton />;

//   if (!properties || properties.length === 0) return <NoPropertiesFound />;

//   const handleEdit = (id, propertyType) => {
//     navigate(`/admin/properties/edit/${propertyType}/${id}`);
//   };
//   const handleDelete = async (id) => {
//     try {
//       // Optional confirmation dialog
//       const confirmDelete = window.confirm(
//         "Are you sure you want to delete this property?"
//       );
//       if (!confirmDelete) return;

//       await api.delete(`/properties/${id}`);

//       fetchProperties();

//       showSuccess("Property deleted successfully.");
//     } catch (error) {
//       console.error("Delete failed:", error);
//       showError("Failed to delete property. Please try again.");
//     }
//   };

//   return (
//     <div className="lg:col-span-2 space-y-4 scroll-overlay">
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
//         {properties.map((prop, idx) => {
//           return (
//             <PropertyCard
//               key={idx}
//               {...prop}
//               onDelete={(id) => handleDelete(id)}
//               onEdit={(id) => handleEdit(id, prop?.type)}
//             />
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// const MyProperties = () => {
//   const [properties, setProperties] = useState([]);
//   const [filteredProperties, setFilteredProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [locations, setLocations] = useState([]);
//   const [filters, setFilters] = useState({
//     city: "",
//     budget: "",
//     size: "",
//     date: "",
//   });

//   const fetchProperties = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/properties/listed-by");
//       // console.log("properties:", res?.data);

//       const formatted = res.data?.data?.map((item) => {
//         const thumbnail =
//           item.images?.find((img) => img.isThumbnail)?.url ||
//           item.images?.[0]?.url;

//         const getPrice = (property) => {
//           switch (item.type) {
//             case "land":
//               return (
//                 property?.expectedPrice ||
//                 property?.pricePerSqft * property?.carpetArea?.value
//               );

//             case "commercial":
//               return (
//                 property?.allowedForConstructionDetails?.expectedPrice ||
//                 property?.price
//               );

//             case "project":
//               return property?.price || property?.floorPlan?.[0]?.expectedPrice;

//             case "residential":
//               return property?.floorPlan?.expectedPrice || property?.price;

//             default:
//               return (
//                 property?.expectedPrice ||
//                 property?.price ||
//                 property?.floorPlan?.expectedPrice
//               );
//           }
//         };

//         return {
//           id: item._id,
//           image: thumbnail,
//           title: item?.title || item.property?.projectName || "Unnamed Project",
//           location: item.location || "",
//           price: formatPrice(getPrice(item.property)) || 0,
//           timeAgo: timeAgo(item.createdAt),
//           type: item.type,
//         };
//       });

//       setProperties(formatted);
//       setFilteredProperties(formatted);
//     } catch (err) {
//       console.error("Error fetching properties:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (properties.length > 0) {
//       const uniqueCities = [
//         ...new Set(
//           properties
//             .map((p) => p?.location?.address?.city)
//             .filter((city) => city && city.trim() !== "")
//         ),
//       ];
//       setLocations(uniqueCities);
//     }
//   }, [properties]);

//   useEffect(() => {
//     fetchProperties();
//   }, []);

//   useEffect(() => {
//     let updated = [...properties];

//     //  CITY FILTER
//     if (filters.city) {
//       updated = updated.filter(
//         (p) =>
//           p.location?.address?.city?.toLowerCase() ===
//           filters.city.toLowerCase()
//       );
//     }

//     // BUDGET FILTER (Price)
//     if (filters.budget) {
//       const [minL, maxL] = filters.budget.split("-").map(Number);
//       const min = minL * 100000;
//       const max = maxL * 100000;

//       updated = updated.filter((p) => {
//         const price = getPrice(p);
//         return price >= min && price <= max;
//       });
//     }

//     //  SIZE FILTER
//     if (filters.size) {
//       let sqft = null;
//       const size = filters.size;

//       updated = updated.filter((p) => {
//         // extract size dynamically per property type
//         sqft =
//           p.property?.carpetArea?.value ||
//           p.property?.floorPlan?.carpetArea?.value ||
//           p.property?.allowedForConstructionDetails?.carpetArea?.value ||
//           p.property?.floors?.totalArea?.value ||
//           0;

//         if (size.includes("+")) {
//           const min = Number(size.replace("+", ""));
//           return sqft >= min;
//         }

//         const [min, max] = size.split("-").map(Number);
//         return sqft >= min && sqft <= max;
//       });
//     }

//     //  DATE FILTER (Created At)
//     if (filters.date) {
//       updated = updated.filter((p) => {
//         const created = new Date(p.createdAt).toISOString().slice(0, 10);
//         return created === filters.date;
//       });
//     }

//     setFilteredProperties(updated);
//   }, [filters, properties]);

//   return (
//     <div className="font-quicksand bg-background py-3 sm:py-4 md:py-6 pl-3 sm:pl-4 md:pl-6 pr-2 sm:pr-3 md:pr-4">
//       {/* Header */}
//       <div className="flex justify-between items-center">
//         <div className="mb-4 cursor-default font-poppins">
//           <h1 className="text-2xl font-semibold text-text-primary mb-1">
//             My Properties
//           </h1>
//           <p className="text-text-muted text-sm">My Plots</p>
//         </div>
//         <div>
//           <AddListingDropdown />
//         </div>
//       </div>

//       {/* Stats Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
//         {statsData.map((stat) => (
//           <StatCard key={stat.id} {...stat} />
//         ))}
//       </div>

//       {/* Main Content Grid */}
//       <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
//         {/* Leads Section - Scrollable */}
//         <div className="lg:col-span-9 space-y-4">
//           <FilterBar
//             filters={filters}
//             setFilters={setFilters}
//             locations={locations}
//           />
//           <PropertyList
//             isLoading={loading}
//             properties={filteredProperties}
//             fetchProperties={fetchProperties}
//           />
//         </div>

//         {/* Sticky Right Sidebar */}
//         <div className="lg:col-span-3">
//           <div className="lg:sticky lg:top-4 space-y-4">
//             <MarketInsightCard />
//             <MarketInsightGraph />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyProperties;
